import React, {useContext} from 'react';
import styles from './productFeatures.module.scss'
import UserContext from '../../../../user/UserContext';

export default function ProductFeatures({
                                            hideFilters,
                                            selectedFilters,
                                            onFiltersUpdate
                                        }) {

    const {userDetails} = useContext(UserContext);

    return (
        <>
            {!hideFilters &&
            <div className={styles.filtersSection}>

                <div>
                    <input
                        id={'promo-only'}
                        type={'checkbox'}
                        name={'promo-only'}
                        checked={selectedFilters.isPromoOnly}
                        aria-checked={selectedFilters.isPromoOnly}
                        onChange={event => onFiltersUpdate({...selectedFilters, isPromoOnly: event.target.checked})}
                    />
                    <label htmlFor={'promo-only'} className={'promo-only-label'}>Promo Only</label>
                </div>
                {userDetails.currentFranchise && !userDetails.currentFranchise.coopOBR && (
                    <div>
                        <input
                            id={'filter-coop-label'}
                            type={'checkbox'}
                            checked={selectedFilters.isCoopOwnLabel}
                            aria-checked={selectedFilters.isCoopOwnLabel}
                            onChange={event => onFiltersUpdate({
                                ...selectedFilters,
                                isCoopOwnLabel: event.target.checked
                            })}
                        />
                        <label htmlFor={'filter-coop-label'} className={'promo-only-label'}>Coop Own Label</label>
                    </div>
                )}
                {userDetails.currentFranchise && !userDetails.currentFranchise.nisaOBR && (
                    <div>
                        <input
                            id={'filter-heritage'}
                            type={'checkbox'}
                            checked={selectedFilters.isHeritageOwnLabel}
                            aria-checked={selectedFilters.isHeritageOwnLabel}
                            onChange={event => onFiltersUpdate({
                                ...selectedFilters,
                                isHeritageOwnLabel: event.target.checked
                            })}
                        />
                        <label htmlFor={'filter-heritage'} className={'promo-only-label'}>Heritage Own Label</label>
                    </div>
                )}
            </div>
            }
            <div className={styles.filtersSection}>
                <div>
                    <input
                        id={'filter-organic'}
                        type={'checkbox'}
                        checked={!!selectedFilters.isOrganic}
                        aria-checked={!!selectedFilters.isOrganic}
                        onChange={event => onFiltersUpdate({...selectedFilters, isOrganic: event.target.checked ? true : null})}
                    />
                    <label htmlFor={'filter-organic'} className={'promo-only-label'}>Organic</label>
                </div>
                <div>
                    <input
                        id={'filter-gluten-free'}
                        type={'checkbox'}
                        checked={!!selectedFilters.isGlutenFree}
                        aria-checked={!!selectedFilters.isGlutenFree}
                        onChange={event => onFiltersUpdate({...selectedFilters, isGlutenFree: event.target.checked ? true : null})}
                    />
                    <label htmlFor={'filter-gluten-free'} className={'promo-only-label'}>Gluten Free</label>
                </div>
                <div>
                    <input
                        id={'filter-vegetarian'}
                        type={'checkbox'}
                        checked={!!selectedFilters.isVegetarian}
                        aria-checked={!!selectedFilters.isVegetarian}
                        onChange={event => onFiltersUpdate({...selectedFilters, isVegetarian: event.target.checked ? true : null})}
                    />
                    <label htmlFor={'filter-vegetarian'} className={'promo-only-label'}>Vegetarian</label>
                </div>
            </div>
            <div className={styles.filtersSection}>
                <div>
                    <input
                        id={'filter-fairtrade'}
                        type={'checkbox'}
                        checked={!!selectedFilters.isFairtrade}
                        aria-checked={!!selectedFilters.isFairtrade}
                        onChange={event => onFiltersUpdate({...selectedFilters, isFairtrade: event.target.checked ? true : null})}
                    />
                    <label htmlFor={'filter-fairtrade'} className={'promo-only-label'}>Fairtrade</label>
                </div>
                <div>
                    <input
                        id={'filter-halal'}
                        type={'checkbox'}
                        checked={!!selectedFilters.isHalal}
                        aria-checked={!!selectedFilters.isHalal}
                        onChange={event => onFiltersUpdate({...selectedFilters, isHalal: event.target.checked ? true : null})}
                    />
                    <label htmlFor={'filter-halal'} className={'promo-only-label'}>Halal</label>
                </div>
                <div>
                    <input
                        id={'filter-vegan'}
                        type={'checkbox'}
                        checked={!!selectedFilters.isVegan}
                        aria-checked={!!selectedFilters.isVegan}
                        onChange={event => onFiltersUpdate({...selectedFilters, isVegan: event.target.checked ? true : null})}
                    />
                    <label htmlFor={'filter-vegan'} className={'promo-only-label'}>Vegan</label>
                </div>
            </div>
        </>
    );
}